import React from 'react';
import { CheckCircle2, BookOpen, Headphones } from 'lucide-react';
import { CTAButton } from './CTAButton';
export function WhatYouGet() {
  return <section className="bg-navy text-white py-16 px-4" data-id="element-238">
      <div className="max-w-3xl mx-auto" data-id="element-239">
        <h2 className="text-3xl md:text-4xl font-bold text-center mb-10 text-gold" data-id="element-240">
          Here's Exactly What You Get Today
        </h2>

        <div className="space-y-6" data-id="element-241">
          <div className="bg-navy-light border border-blue-800 rounded-xl p-6 flex gap-4 items-start shadow-lg" data-id="element-242">
            <CheckCircle2 className="text-green-400 flex-shrink-0 mt-1" size={28} data-id="element-243" />
            <div data-id="element-244">
              <h3 className="text-xl font-bold mb-2" data-id="element-245">
                Core eBook: Voices of Freedom{' '}
                <span className="text-gold ml-2 text-sm font-normal" data-id="element-246">
                  ($47.97 Value)
                </span>
              </h3>
              <p className="text-gray-300 mb-2" data-id="element-247">
                The complete digital book on the pillars of liberty. Read it on
                any device — phone, tablet, or computer — and build an
                unshakeable foundation for your values.
              </p>
              <div className="flex items-center gap-2 text-blue-300 text-sm mt-2" data-id="element-248">
                <Headphones size={14} data-id="element-249" />
                <span className="italic" data-id="element-250">
                  + FREE Audiobook version included as a gift (75 min narration)
                </span>
              </div>
            </div>
          </div>

          <div className="bg-navy-light border border-blue-800 rounded-xl p-6 flex gap-4 items-start shadow-lg relative overflow-hidden" data-id="element-251">
            <div className="absolute top-0 right-0 bg-patriot-red text-white text-xs font-bold px-3 py-1 rounded-bl-lg" data-id="element-252">
              FREE BONUS
            </div>
            <CheckCircle2 className="text-green-400 flex-shrink-0 mt-1" size={28} data-id="element-253" />
            <div data-id="element-254">
              <h3 className="text-xl font-bold mb-2" data-id="element-255">
                Remembering Charlie Kirk{' '}
                <span className="text-gold ml-2 text-sm font-normal" data-id="element-256">
                  ($23.98 Value)
                </span>
              </h3>
              <p className="text-gray-300 mb-2" data-id="element-257">
                The digital tribute book and timeline of a movement that changed
                America. Understand the history of modern conservative activism.
              </p>
              <div className="flex items-center gap-4 text-blue-300 text-sm mt-2" data-id="element-258">
                <span className="flex items-center gap-1" data-id="element-259">
                  <BookOpen size={14} data-id="element-260" />
                  eBook
                </span>
                <span className="flex items-center gap-1" data-id="element-261">
                  <Headphones size={14} data-id="element-262" />
                  Audiobook
                </span>
              </div>
            </div>
          </div>

          <div className="bg-navy-light border border-blue-800 rounded-xl p-6 flex gap-4 items-start shadow-lg relative overflow-hidden" data-id="element-263">
            <div className="absolute top-0 right-0 bg-patriot-red text-white text-xs font-bold px-3 py-1 rounded-bl-lg" data-id="element-264">
              FREE BONUS
            </div>
            <CheckCircle2 className="text-green-400 flex-shrink-0 mt-1" size={28} data-id="element-265" />
            <div data-id="element-266">
              <h3 className="text-xl font-bold mb-2" data-id="element-267">
                The Last Patriot{' '}
                <span className="text-gold ml-2 text-sm font-normal" data-id="element-268">
                  ($23.99 Value)
                </span>
              </h3>
              <p className="text-gray-300 mb-2" data-id="element-269">
                An actionable digital guide on how to survive and thrive in a
                cancel-culture world without compromising your core beliefs.
              </p>
              <div className="flex items-center gap-4 text-blue-300 text-sm mt-2" data-id="element-270">
                <span className="flex items-center gap-1" data-id="element-271">
                  <BookOpen size={14} data-id="element-272" />
                  eBook
                </span>
                <span className="flex items-center gap-1" data-id="element-273">
                  <Headphones size={14} data-id="element-274" />
                  Audiobook
                </span>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-10 text-center" data-id="element-275">
          <p className="text-2xl font-bold mb-2" data-id="element-276">
            Total Value:{' '}
            <span className="line-through text-gray-400" data-id="element-277">$95.94</span>
          </p>
          <p className="text-3xl font-bold text-gold mb-8" data-id="element-278">
            Yours Today For Just $29.97
          </p>

          <div className="max-w-md mx-auto" data-id="element-279">
            <CTAButton data-id="element-280">GET THE COMPLETE BUNDLE — $29.97</CTAButton>
          </div>
        </div>
      </div>
    </section>;
}